import { createApp } from 'vue'
import LineMapApp from '../pages/line-map/LineMapApp.vue'

// Page-scoped entrypoint (see README and the #67 pilot): Turbo keeps the
// JS context and its listeners across visits and a `type="module"` entrypoint
// is evaluated only once, so this mounts only on line_map#show and users#show.
//
// Both screens render the same map widget: `line_map#show` shows the full route
// list + detail panel, `users#show` shows the map only (the legacy `nopad`
// mode). The view renders the configuration on the `#line-map-app` mount
// element as `data-*` attributes; the entrypoint reads them and passes them to
// the component as props.
const MOUNT_ID = 'line-map-app'
const ENTRY = 'line-map'

function isLineMapPage() {
  const body = document.body
  if (!body) return false
  const controller = body.dataset.controller
  const action = body.dataset.action
  return (
    (controller === 'line_map' && action === 'show') ||
    (controller === 'users' && action === 'show')
  )
}

let app = null

function mount() {
  // Unmount the previous page's app before mounting the next one. We do not
  // unmount on `turbo:before-visit` here: the map tears itself down via
  // its own `turbo:before-visit` / `beforeunload` handlers (aborting
  // in-flight AJAX) which must run before the app is destroyed.
  unmount()
  if (!isLineMapPage()) return

  const el = document.getElementById(MOUNT_ID)
  if (!el || el.dataset.viteEntry !== ENTRY) return

  app = createApp(LineMapApp, {
    mapId: el.dataset.id,
    withPanel: el.dataset.withPanel === 'true',
    editable: el.dataset.editable === 'true',
    loggedIn: el.dataset.loggedIn === 'true',
    userName: el.dataset.userName || '',
    userImageUrl: el.dataset.userImageUrl || '',
    dropIconUrl: el.dataset.dropIconUrl || '',
  })
  app.mount(el)
}

function unmount() {
  if (app) {
    app.unmount()
    app = null
  }
}

document.addEventListener('turbo:load', mount)
window.addEventListener('beforeunload', unmount)

// When this module is evaluated after Turbo has already dispatched its
// initial `turbo:load` (e.g. loaded on demand), mount right away.
if (document.readyState === 'complete') mount()
